import React, { Fragment } from "react";

const CommunityBanner = () => {
  return (
    <Fragment>
      <img
        className="banner-image"
        src={
          "https://ime.sfo3.cdn.digitaloceanspaces.com/img/secondary_logo.png"
        }
      />
    </Fragment>
  );
};

export default CommunityBanner;
